export const GET_VENDOR: string = 'GET_VENDOR';
export const GET_INSTALLED_VENDORS: string = 'GET_INSTALLED_VENDORS';
export const GET_ALL_PROJECTS: string = 'GET_ALL_PROJECTS';
export const UPLOAD_PROJECT: string = 'UPLOAD_PROJECT';
export const SET_INSTALLED_VENDORS: string = 'setInstalledVendors';
export const SET_ALL_PROJECTS: string = 'setAllProjects';
export const SET_ALL_VENDORS: string = 'setAllVendors';
export const GET_AWS_ACCOUNTS: string = 'GET_AWS_ACCOUNTS';
export const SET_AWS_ACCOUNTS: string = 'setAwsAccounts';
export const DELETE_AWS_ACCOUNT = 'DELETE_AWS_ACCOUNT';
export const DELETE_SET_AWS_ACCOUNTS = 'deleteAwsAccount';
